import React from 'react';
import { TableRow } from '@material-ui/core';
import Seo from './seo';

function Alteracao({ alteracao, setAlteracao }) {
  return (
    <>
      <TableRow>
        <Seo
          etapas="Mapeamento"
          status={alteracao.mapeamento_status}
          setStatus={(data) =>
            setAlteracao((prev) => ({ ...prev, mapeamento_status: data }))
          }
          encerramento={alteracao.mapeamento_encerramento}
          setEncerramento={(data) =>
            setAlteracao((prev) => ({ ...prev, mapeamento_encerramento: data }))
          }
          observacao={alteracao.mapeamento_observacao}
          setObservacao={(data) =>
            setAlteracao((prev) => ({ ...prev, mapeamento_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Elaboração Minuta Contratual"
          status={alteracao.minuta_status}
          setStatus={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              minuta_status: data,
            }))
          }
          encerramento={alteracao.minuta_encerramento}
          setEncerramento={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              minuta_encerramento: data,
            }))
          }
          observacao={alteracao.minuta_observacao}
          setObservacao={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              minuta_observacao: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Viabilidade"
          status={alteracao.viabilidade_federal_status}
          setStatus={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              viabilidade_federal_status: data,
            }))
          }
          encerramento={alteracao.viabilidade_federal_encerramento}
          setEncerramento={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              viabilidade_federal_encerramento: data,
            }))
          }
          observacao={alteracao.viabilidade_federal_observacao}
          setObservacao={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              viabilidade_federal_observacao: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="DBE"
          status={alteracao.dbe_status}
          setStatus={(data) =>
            setAlteracao((prev) => ({ ...prev, dbe_status: data }))
          }
          encerramento={alteracao.dbe_encerramento}
          setEncerramento={(data) =>
            setAlteracao((prev) => ({ ...prev, dbe_encerramento: data }))
          }
          observacao={alteracao.dbe_observacao}
          setObservacao={(data) =>
            setAlteracao((prev) => ({ ...prev, dbe_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Certificado Bird ID"
          status={alteracao.certificado_status}
          setStatus={(data) =>
            setAlteracao((prev) => ({ ...prev, certificado_status: data }))
          }
          encerramento={alteracao.certificado_encerramento}
          setEncerramento={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              certificado_encerramento: data,
            }))
          }
          observacao={alteracao.certificado_observacao}
          setObservacao={(data) =>
            setAlteracao((prev) => ({ ...prev, certificado_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Registro"
          status={alteracao.registro_status}
          setStatus={(data) =>
            setAlteracao((prev) => ({ ...prev, registro_status: data }))
          }
          encerramento={alteracao.registro_encerramento}
          setEncerramento={(data) =>
            setAlteracao((prev) => ({ ...prev, registro_encerramento: data }))
          }
          observacao={alteracao.registro_observacao}
          setObservacao={(data) =>
            setAlteracao((prev) => ({ ...prev, registro_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Inscrição Municipal"
          status={alteracao.inscricao_municipal_status}
          setStatus={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              inscricao_municipal_status: data,
            }))
          }
          encerramento={alteracao.inscricao_municipal_encerramento}
          setEncerramento={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              inscricao_municipal_encerramento: data,
            }))
          }
          observacao={alteracao.inscricao_municipal_observacao}
          setObservacao={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              inscricao_municipal_observacao: data,
            }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Licenciamento"
          status={alteracao.licenciamento_status}
          setStatus={(data) =>
            setAlteracao((prev) => ({ ...prev, licenciamento_status: data }))
          }
          encerramento={alteracao.licenciamento_encerramento}
          setEncerramento={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              licenciamento_encerramento: data,
            }))
          }
          observacao={alteracao.licenciamento_observacao}
          setObservacao={(data) =>
            setAlteracao((prev) => ({
              ...prev,
              licenciamento_observacao: data,
            }))
          }
        />
      </TableRow>
    </>
  );
}

export default Alteracao;
